export const ACTIVITY_CATEGORIES_DEVIDER_ALL_TYPE_REQUEST = 'ACTIVITY_CATEGORIES_DEVIDER_ALL_TYPE_REQUEST';
export const ACTIVITY_CATEGORIES_DEVIDER_ALL_TYPE_SUCCESS = 'ACTIVITY_CATEGORIES_DEVIDER_ALL_TYPE_SUCCESS';
export const ACTIVITY_CATEGORIES_DEVIDER_ALL_TYPE_FAIL = 'ACTIVITY_CATEGORIES_DEVIDER_ALL_TYPE_FAIL';

